export default __webpack_public_path__ + "images/p12.jpg";